import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frequency", "plans"]
  static classes = ["activeFrequency", "inactiveFrequency", "inactivePlans"]

  connect() {
    const preferred = this.frequencyTargets.find((button) => button.dataset.frequency === "monthly")
    this.switchTo(preferred ? "monthly" : this.frequencyTargets[0]?.dataset.frequency)
  }

  switch(event) {
    event.preventDefault()
    this.switchTo(event.currentTarget.dataset.frequency)
  }

  switchTo(frequency) {
    if (!frequency) return

    this.frequencyTargets.forEach((button) => {
      const active = button.dataset.frequency === frequency
      if (active) {
        button.classList.remove(...this.inactiveFrequencyClasses)
        button.classList.add(...this.activeFrequencyClasses)
      } else {
        button.classList.remove(...this.activeFrequencyClasses)
        button.classList.add(...this.inactiveFrequencyClasses)
      }
      button.setAttribute("aria-pressed", active ? "true" : "false")
    })

    this.plansTargets.forEach((container) => {
      const active = container.dataset.frequency === frequency
      if (active) {
        container.classList.remove(...this.inactivePlansClasses)
      } else {
        container.classList.add(...this.inactivePlansClasses)
      }
    })
  }
}
